import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.number.constructor.js";
import Vue from 'vue';
import DarkMixin from "../../mixins/dark.js";
import TagMixin from "../../mixins/tag.js";
import { RouterLinkMixin } from "../../mixins/router-link.js";
import ListenersMixin from "../../mixins/listeners.js";
import { uniqueSlot } from "../../utils/slot.js";
import { stopAndPrevent } from "../../utils/event.js";
import { isKeyCode } from "../../utils/key-composition.js";
export default Vue.extend({
  name: 'QItem',
  mixins: [DarkMixin, RouterLinkMixin, TagMixin, ListenersMixin],
  props: {
    active: Boolean,
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  computed: {
    isActionable: function isActionable() {
      return this.clickable === true || this.hasRouterLink === true || this.tag === 'a' || this.tag === 'label';
    },
    isClickable: function isClickable() {
      return this.disable !== true && this.isActionable === true;
    },
    classes: function classes() {
      var _ref;

      return _ref = {
        'q-item--clickable q-link cursor-pointer': this.isClickable,
        'q-focusable q-hoverable': this.isClickable === true && this.manualFocus === false,
        'q-manual-focusable': this.isClickable === true && this.manualFocus === true,
        'q-manual-focusable--focused': this.isClickable === true && this.focused === true,
        'q-item--dense': this.dense,
        'q-item--dark': this.isDark,
        'q-item--active': this.active
      }, _defineProperty(_ref, this.activeClass, this.active === true && this.hasRouterLink !== true && this.activeClass !== void 0), _defineProperty(_ref, 'disabled', this.disable), _ref;
    },
    style: function style() {
      if (this.insetLevel !== void 0) {
        var dir = this.$q.lang.rtl === true ? 'Right' : 'Left';
        return _defineProperty({}, 'padding' + dir, 16 + this.insetLevel * 56 + 'px');
      }
    },
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({}, this.qListeners), {}, {
        click: this.__onClick,
        keyup: this.__onKeyup
      });
    }
  },
  methods: {
    __getContent: function __getContent(h) {
      var child = uniqueSlot(this, 'default', []);
      this.isClickable === true && child.unshift(h('div', {
        staticClass: 'q-focus-helper',
        attrs: {
          tabindex: -1
        },
        ref: 'blurTarget'
      }));
      return child;
    },
    __onClick: function __onClick(e) {
      if (this.isClickable === true) {
        if (this.$refs.blurTarget !== void 0) {
          if (e.qKeyEvent !== true && document.activeElement === this.$el) {
            this.$refs.blurTarget.focus();
          } else if (document.activeElement === this.$refs.blurTarget) {
            this.$el.focus();
          }
        }

        this.$emit('click', e);
      }
    },
    __onKeyup: function __onKeyup(e) {
      if (this.isClickable === true && isKeyCode(e, 13) === true) {
        stopAndPrevent(e); // for ripple

        e.qKeyEvent = true; // for click trigger

        var evt = new MouseEvent('click', e);
        evt.qKeyEvent = true;
        this.$el.dispatchEvent(evt);
      }

      this.$emit('keyup', e);
    }
  },
  render: function render(h) {
    var data = _defineProperty({
      staticClass: 'q-item q-item-type row no-wrap',
      class: this.classes,
      style: this.style
    }, this.hasRouterLink === true ? 'nativeOn' : 'on', this.onEvents);

    if (this.isClickable === true) {
      data.attrs = {
        tabindex: this.tabindex || '0'
      };
    } else if (this.isActionable === true) {
      data.attrs = {
        'aria-disabled': 'true'
      };
    }

    if (this.hasRouterLink === true) {
      data.tag = 'a';
      data.props = this.routerLinkProps;
      return h('router-link', data, this.__getContent(h));
    }

    return h(this.tag, data, this.__getContent(h));
  }
});